import Vue from 'vue'
import './plugins/vuetify'
import './plugins/snotify'
import i18n from './plugins/i18n.js'
import router from './plugins/router'
import { store } from './plugins/store.js'
import App from './App.vue'

import './styles/flexbox.css'
import './styles/app.css'
import '@mdi/font/css/materialdesignicons.min.css'
import "vue-snotify/styles/material.css"
import linkify from 'vue-linkify'

Vue.config.productionTip = false;
Vue.directive('linkified', linkify)

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');
